import { getUserAddressData, getUsersData } from "../utility/api/services/ManageData";
import { usersData } from "./Reducers/userRedux";

const userHandler = () => {
    return (dispatch) => {
      getUserAddressData().then((res) => {
        console.log("res", res);
        const data = res?.data?.map((e, i) => ({ ...e, sn: i + 1 }));
        if (data) {
          dispatch(usersData(data));
        }
      });
    };
  };

  export default {userHandler, }